"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const back_to_top_1 = __importDefault(require("./modules/back-to-top"));
const menu_1 = __importDefault(require("./modules/menu"));
//import "../sass/main";
//importAll(require.context('../img', false, /\.(jpg|svg)$/)); // Importer toutes les fontes.
/**
 * Gérer l'intéractivité entre le bouton menu et le contenant des liens de
 * navigation.
 */
const menu = document.getElementById("menu");
const navItems = document.getElementById("nav-items");
if (menu instanceof HTMLDivElement &&
    navItems instanceof HTMLDivElement) {
    new menu_1.default(menu, navItems);
}
/**
 * Gérer l'apparition et la disparition du bouton "back to top".
 */
const backToTop = new back_to_top_1.default();
backToTop.init();
/**
 * Permettre le Hot Module Replacement.
 * @see {@link https://webpack.js.org/api/hot-module-replacement} pour plus d'informations.
 */
/*if (module.hot) {
    module.hot.accept();
}*/
/**
 * Importer tous les fichier d'un répertoire avec, ou sans, récursivité.
 *
 * @param requireContext __WebpackModuleApi.RequireContext
 * @see {@link https://webpack.js.org/guides/dependency-management/#context-module-api} pour plus d'informations.
 */
/*export function importAll (requireContext: __WebpackModuleApi.RequireContext): void {
    requireContext.keys().forEach(requireContext);
}*/
